// extracted by mini-css-extract-plugin
module.exports = {"issueForm":"style_issueForm__558v2","formHeader":"style_formHeader__23Du3"};